import React from 'react'
import SchoolAccount from './SchoolAccount'
import gql from 'graphql-tag'
import DataContainer from 'components/DataContainer/DataContainer'
import ModalContext from 'components/Context/ModalContext'

const queries = [
  {
    query: gql`
      {
        me {
          _id
          name
          email
          schoolName
          subscription {
            id
            current_period_end
          }
          subscriptionEndDate
          school {
            _id
            name
            twitter
            teachers {
              _id
              name
              email
            }
            licence
          }
          ambassador
        }
      }
    `,
    props: ({ data }) => {
      if (data.loading || data.error) {
        return { loading: data.loading, error: data.error }
      }

      const school = data.me.school || {}
      return {
        loggedInUser: data.me._id,
        schoolDetails: {
          _id: school._id,
          name: school.name || data.me.schoolName,
          twitter: school.twitter
        },
        teachers: school.teachers || [{
          _id: data.me._id,
          name: data.me.name,
          email: data.me.email
        }],
        subscriptionDetails: {
          subscription: data.me.subscription,
          subscriptionEndDate: data.me.subscriptionEndDate,
          licence: school.licence
        },
        ambassador: data.me.ambassador,
        isSubscribed: data.me.isSubscribe
      }
    },
    options: {
      fetchPolicy: 'network-only'
    }
  }
]

const mutations = [
  {
    mutation: gql`
      mutation updateSchool($school: UpdateSchoolInput) {
        updateSchool(school: $school) {
          _id
        }
      }
    `,
    props: ({ mutate }) => ({
      updateSchoolDetails: async details => {
        await mutate({
          variables: {
            school: details
          }
        })
      }
    })
  },
  {
    mutation: gql`
      mutation updateMe($user: UserInput) {
        updateMe(user: $user) {
          _id
        }
      }
    `,
    props: ({ mutate }) => ({
      updateTrialSchoolDetails: async (details) => {
        await mutate({
          variables: {
            user: details
          }
        })
      }
    })
  },
  {
    mutation: gql`
      mutation deleteTeacherFromSchool($teacherId: String!, $schoolId: String!, $userPassword: String!) {
        deleteTeacherFromSchool(teacherId: $teacherId, schoolId: $schoolId, userPassword: $userPassword) {
          _id
        }
      }
    `,
    props: ({ mutate }) => ({
      deleteTeacher: async (teacherId, schoolId, userPassword) => {
        await mutate({
          variables: {
            teacherId,
            schoolId,
            userPassword
          }
        })
      }
    })
  },
  {
    mutation: gql`
      mutation addTeacherToSchool($email: String!, $schoolId: String!) {
        addTeacherToSchool(email: $email, schoolId: $schoolId) {
          _id
        }
      }
    `,
    props: ({ mutate }) => ({
      addTeacher: async (email, schoolId) => {
        await mutate({
          variables: {
            email,
            schoolId
          }
        })
      }
    })
  },
  {
    mutation: gql`
      mutation ambassadorMutation {
        ambassador
      }
    `,
    props: ({ mutate }) => ({
      ambassadorSignUp: mutate
    })
  }
]

class SchoolAccountContainer extends React.Component {
  render () {
    return (
      <ModalContext.Consumer>
        {modal => (
          <SchoolAccount {...this.props} modal={modal} />
        )}
      </ModalContext.Consumer>
    )
  }
}

export default props => (
  <DataContainer queries={queries} mutations={mutations}>
    <SchoolAccountContainer {...props} />
  </DataContainer>
)
